module.exports = __webpack_public_path__ + "img/mee.f59e309f.png";